<template>
<v-menu v-if="currentUser"
        location="bottom end"
        origin="top right"
        transition="scale-transition">
    <template v-slot:activator="{ props }">
        <v-btn class="mx-2"
               icon
               variant="flat"
               theme="dark"
               elevation="0"
               size="40"
               color="#212121"
               v-bind="props">

            {{ currentUser.firstName[0] }}{{ currentUser.lastName[0]}}
        </v-btn>
    </template>
    <v-list :tile="false" nav>
        <div>
            <app-bar-item>
                <v-list-item-title title="Login"
                                   v-if="$store.state.authentication.loggedIn"
                                   class="sidebar-nav-item">
                    <router-link :to="{ name: 'buildings' }">Login</router-link>
                </v-list-item-title>
                <div v-else>
                    <v-list-item-title title="Logout">
                        {{ currentUser.firstName }} {{ currentUser.lastName }}
                    </v-list-item-title>
                    <v-divider></v-divider>

                    <template v-if="buildingId">
                        <router-link class="more-nav-buttons"
                                     :to="{
          name: 'expensetypes',
          params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                            <v-list-item v-if="buildingId" class="nav-item active small">

                                <span class="nav-title small">Add New Expense Type</span>

                            </v-list-item>
                        </router-link>
                        <router-link class="more-nav-buttons"
                                     :to="{
          name: 'suppliers',
        params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                            <v-list-item v-if="buildingId" class="nav-item active small">
                                <span class="nav-title small">Providers</span>
                            </v-list-item>
                        </router-link>
                        <router-link class="more-nav-buttons"
                                     :to="{
          name: 'recurringexpenses',
         params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                            <v-list-item v-if="buildingId" class="nav-item active small">
                                <span class="nav-title small">Recurring Expenses</span>
                            </v-list-item>
                        </router-link>
                        <router-link class="more-nav-buttons"
                                     :to="{
          name: 'additionalindex',
         params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                            <v-list-item v-if="buildingId" class="nav-item active small">
                                <span class="nav-title small">Additional Expenses</span>
                            </v-list-item>
                        </router-link>
                        <router-link class="more-nav-buttons"
                                     :to="{
          name: 'expensesbymonth',
      params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                            <v-list-item v-if="buildingId" class="nav-item active small">
                                <span class="nav-title small">Additional Reports</span>
                            </v-list-item>
                        </router-link>
                        <!--<v-list-item v-if="buildingId && ismore" class="nav-item active"><router-link class="more-nav-buttons" @click.native="trueMore" :to="{ name: 'more', params:{buildingId:buildingId, buildingName:buildingName}}">Tutorials</router-link></v-list-item>-->
                        <router-link class="more-nav-buttons"
                                     :to="{
          name: 'committees',
        params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                            <v-list-item v-if="buildingId" class="nav-item active small">
                                <span class="nav-title small">Committee</span>
                            </v-list-item>
                        </router-link>
                        <v-divider></v-divider>
                    </template>

                    <v-list-item-title title="Logout" class="nav-item active small">
                        <a href="#" @click.prevent="logout()">  <span class="nav-title small">Logout</span></a>
                    </v-list-item-title>
                </div>

                <v-list-item-title title="Account"
                                   class="nav-item active small">
                    <router-link :to="{ name: 'account' }">  <span class="nav-title small">Account</span></router-link>
                </v-list-item-title>
                <v-list-item-title title="Users"
                                   v-if="currentUser.role == 'Admin'"
                                   class="nav-item active small">
                    <router-link :to="{ name: 'users' }">  <span class="nav-title small">Users</span></router-link>
                </v-list-item-title>
                <v-list-item-title title="Settings"
                                   v-if="userRoleManagement"
                                   class="nav-item active small">
                    <router-link :to="{ name: 'settings' }">  <span class="nav-title small">Settings</span></router-link>
                </v-list-item-title>

            </app-bar-item>
        </div>
    </v-list>
</v-menu>
</template>
<script>
import { mapState } from "vuex";
    import { authenticationService } from "@/_services";
    export default {
        data: function () {
            return {
                filter: "",
                currentUser: null,
                //numberOfAllowedBuildings : 0,
                role: "",
            };
        },
        created() {
            authenticationService.currentUser.subscribe((x) => (this.currentUser = x));

            // EventBus.$on('menuDrawerClicked', (drawer)=>{
            //     this.drawer=drawer
            // })
        },
        computed:{
            ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    buildingId(){
      if(this.building != null)
        return  this.building.id;
      return ""
            },
            userRoleManagement(){
        if (this.currentUser && this.currentUser.role == 'Owner')
            return false;
        return true;
    },
        },
        methods: {
            logout() {
                this.$store.commit('building/CLEAR_CURRENT_BUILDING')
                this.$store.commit('building/CLEAR_BUILDINGS')
                this.$store.commit('property/CLEAR_CURRENT_PROPERTY')
                this.$store.commit('property/CLEAR_CURRENT_PROPERTY_NAME')
                this.$store.commit('property/CLEAR_CURRENT_PROPERTY_ID')
                sessionStorage.clear()
                authenticationService.logout();
                this.$router.push({
                    name: "login",
                   
                });
            }
        }
    }
</script>